var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "40px",
    viewBox: "0 0 42 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-27",
    transform: "translate(0.933912, 0.212606)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#97A5B8",
    transform: "translate(20.083315, 31.311104) rotate(90.000000) translate(-20.083315, -31.311104) ",
    x: 12.5833146,
    y: 11.3111043,
    width: 15,
    height: 40,
    rx: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CED7DF",
    cx: 19.6538389,
    cy: 10.0507234,
    r: 10
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileWhite);
export default __webpack_public_path__ + "static/media/profile_white.80ad9e8f777c09e16d13a78bfefed6c0.svg";
export { ForwardRef as ReactComponent };